'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _webUtils = require('@vezeeta/web-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var signOut = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var token, signOutCall, signOutBody;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
            signOutCall = new _webUtils.API();
            signOutBody = {
              Token: token
            };


            signOutCall.post(_webUtils.Urls.signOut, signOutBody);
            sessionStorage.removeItem('session');
            _webUtils.Cookie.getAllCookies().forEach(function (cookie) {
              return _webUtils.Cookie.remove(cookie, { domain: process.env.REACT_APP_TOKEN_DOMAIN });
            });

            _webUtils.Cookie.set(_webUtils.Cookie.RETURN_URL, window.location.origin);
            window.location.href = process.env.REACT_APP_ACCOUNTS_URL;

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function signOut() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = signOut;
module.exports = exports['default'];